<template>
  <div class="home">
    <header>
      <img :src="`${imageRoot}acheader.png`" />
    </header>
    <br />
    <div class="container">
      <h2>It starts and ends with you</h2>
      <div class="list-out">
        <div class="list-out-item">
          <h3>Holy Shit, how did this happen.</h3>
          <div class="problem-chart-holder">
            <pie-chart :chartId="`The Problem`"
              :width="320"
              :height="320"/>
          </div>
          <h4>Facts and Numbers</h4>
          <ul>
            <li>There are around 342.6 million people in the US right now.</li>
            <li>The Census figure tells us that 73.6% of the citizen voting-age population was registered and 65.3% voted.</li>
            <li>The 2024 election had 32.8% of people voting for the current disaster and 31.8% for the lesser of two evils.</li>
            <li>1.2% voted in opposition to both options.</li>
            <li>34.2% did not vote at all.</li>
          </ul>
          <p>Looking at the data it is clear that the majority of people in this country do not agree with either party.  This is a symptom of a problem that could likely be fixed if the country wants to pursue the life, liberty and all of the freedom they say they want.  The republicans nor the democrats provide a secure path to this as most of the officials from the president down do not act on behalf of the american voters or residents of this country.</p>
          <p>Republicans lie to their voters and misrepresent what they do and plan to do.  Data proves that when republicans are in office, deficit goes up, the economy underperforms for the average man, jobs are lost and the world stage is always at risk of some nonsense war.  This pattern is demonstrable and guaranteed repeatable.  Currently all the republican party has left is an open grift on their supporters, a non-stop culture war, marginilization of minority communities and a campaign of fear and hate to keep uneducated individuals convinced the democrats want to kill them or stick them in camps.</p>
          <p>Democracts on the other hand run a balanced economy, job growth and manage to bring some changes to the system to benefit the every day human, but at the same time they fail to deliver on things that are attainable when they are in power.  They get things done, but they don't focus on their supporters, essentially because thy know they do not have to.  Democrats aren't putting people in camps and pushing fear on people, they don't need to, the other party does so that just forces educated people to say, I have to vote blue because red bad.</p>
          <p>The whole system now has been rounded down to vote blue no matter who which in no way fixes this problem.  The reason we are where we are is for this bullshit philosophy.  Just because someone has a blue dot next to their name in no way, shap or form indicate they will vote on democratic values. Traditional democratic leadership fails their constituents regulary and they just do not care.  If at any point commons sense indiciduals existed in the house and senate we ould be in a different place.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PieChart from '@/components/charts/PieChart.vue'
export default {
  components: { PieChart },
  name: 'HomeView'
}
</script>
